<div class="filter-element d-none d-md-flex">
  <div ngbDropdown>
    <button class="btn btn-outline-primary" id="dropdownManual" ngbDropdownToggle>
      <span translate>Functions</span>
    </button>

    <div ngbDropdownMenu aria-labelledby="dropdownManual">
      @if (isHigherThanAdmin) {
        <button ngbDropdownItem (click)="onEditSignals()">
          <span class="fa-solid fa-pen"></span>
          <span translate>Edit signals</span>
        </button>
      }
      <button ngbDropdownItem (click)="onToggleUseColorPalette()" [ngClass]="{'active': useColorPalette}">
        <span class="fa-solid fa-palette"></span>
        <span translate>Use color palette</span>
      </button>
      <button ngbDropdownItem (click)="onXlsExport()">
        <span class="fa-solid fa-file-excel"></span>
        <span translate>Export XLS</span>
      </button>
      <button ngbDropdownItem (click)="onCsvExport()">
        <span class="fa-solid fa-file-csv"></span>
        <span translate>Export CSV</span>
      </button>
    </div>
  </div>
</div>
